import { ITochiChicken } from "@snackpass/snackpass-types";
import { Color } from "three";
import tinycolor from "tinycolor2";

export const MIN_COLORS = 1;
export const MAX_COLORS = 3;

export const stringToColor = (
  color: string,
  chicken?: ITochiChicken
): Color => {
  const chickenColor = getChickenColor(color, chicken);
  // Do not process if gradient
  color = chickenColor && !Array.isArray(chickenColor) ? chickenColor : color;
  const c = tinycolor(color);
  if (!c.isValid()) {
    throw new Error(`Unrecognized color ${color}`);
  }
  return new Color(c.toRgbString());
};

export const stringArrToColor = (
  colors: string[],
  chicken?: ITochiChicken
): Color[] => {
  const chickenColors = getChickenColor(colors[0], chicken);
  if (chickenColors) {
    colors = Array.isArray(chickenColors) ? chickenColors : [chickenColors];
  }
  colors = padColorArray(colors, MAX_COLORS);
  const result: Color[] = [];
  for (const color of colors) {
    result.push(stringToColor(color, chicken));
  }
  return result;
};

export const getChickenColor = (color: string, chicken?: ITochiChicken) => {
  switch (color) {
    case "CHICKEN-PRIMARY":
      return chicken
        ? chicken.genes.primary
        : ["#FFFFFF", "#FFFFFF", "#000000"];
    case "CHICKEN-SECONDARY":
      return chicken ? chicken.genes.secondary : "#FFFFFF";
    case "CHICKEN-DECAL":
      return chicken ? chicken.genes.tertiary : "#FFFFFF";
    case "CHICKEN-EYES":
      return chicken ? chicken.genes.eyes : ["#FFFFFF", "#FFFFFF", "#000000"];
    default:
      return null;
  }
};

export function getColorPos(colors: string[], colorPos?: number[]) {
  if (colorPos && colorPos.length === colors.length) {
    return colorPos;
  } else {
    colorPos = [];
    if (colors.length <= 1)
      throw new Error("Must have more than one color in gradient");
    for (let i = 0; i < colors.length; ++i) {
      colorPos.push(i * (1 / (colors.length - 1)));
    }
    return colorPos;
  }
}

// Pad to let GLSL allow for different lengths between masks

export const padStringArray = (arr: string[]) => {
  if (arr.length === 1) return [arr[0], arr[0], arr[0]];
  return arr;
};

export const padColorArray = (arr: string[], maxlen: number) => {
  const temp = [...arr];
  while (temp.length < maxlen) temp.push(temp[temp.length - 1]);
  return temp;
};

export const padColorPosArray = (arr: number[], maxlen: number) => {
  const temp = [...arr];
  while (temp.length < maxlen) temp.push(-1);
  return temp;
};
